import CoRegistration from './CoRegistration'
export default CoRegistration
